import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api/tgc`;

const client = axios.create({ baseURL: API, timeout: 15000 });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("tgc_jwt");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  // Attach server-side admin unlock token on every /admin/* request.
  // Stored in sessionStorage after a one-time unlock modal — cleared on tab close.
  const url = (cfg.url || "").toString();
  if (url.includes("/admin/") || url.startsWith("/admin")) {
    const at = sessionStorage.getItem("tgc_admin_access");
    if (at) cfg.headers["X-Admin-Access-Token"] = at;
  }
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const cfgUrl = (err.config?.url || "").toString();
      if (cfgUrl.includes("/admin/") || cfgUrl.startsWith("/admin")) {
        // Admin token wrong / missing — drop it so the gate re-prompts.
        sessionStorage.removeItem("tgc_admin_access");
      } else {
        localStorage.removeItem("tgc_jwt");
      }
    }
    return Promise.reject(err);
  }
);

export default client;
